import React from 'react';

const IconLoader = () => (
  <svg id="hexagon" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g id="B" transform="translate(36, 33)" fill="#00acff" style={{ opacity: 0 }}>
        <text
          fontFamily="system-ui,Calibre-Medium, Calibre,sans-serif"
          fontSize="50"
          fontWeight="400"
          letterSpacing="4.16666603">
          <tspan x="-10.50" y="33.5">
            JR
          </tspan>
        </text>
      </g>
      <path
        stroke="#00acff"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
           L 11, 27
           L 11, 72
           L 50, 95
           L 89, 73
           L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
